module.exports = __webpack_public_path__ + "img/bomba_zmag.9dd07349.jpg";